import merge from 'lodash/merge';
import xssOriginal, { escapeHtml, safeAttrValue, whiteList } from 'xss';

/** Default whitelist plus tags from trusted Markdown (e.g. task list checkboxes). */
const SANITIZE_HTML_WHITE_LIST = {
  ...whiteList,
  input: ['type', 'class', 'checked', 'disabled'],
};

function xss(dirty, customOptions) {
  const defaultOptions = merge(
    {},
    { whiteList: SANITIZE_HTML_WHITE_LIST },
    {
      onTagAttr(tag, name, value) {
        if (
          tag === 'input' &&
          name === 'type' &&
          String(value).trim().toLowerCase() !== 'checkbox'
        ) {
          return '';
        }
        const isClass = name === 'class';
        const isStyle = name === 'style';
        const isData = name?.startsWith('data');
        if (isClass || isStyle || isData) {
          const safeValue = safeAttrValue(tag, name, value);
          return `${name}="${safeValue}"`;
        }
        return undefined;
      },
    },
  );
  const options = customOptions || defaultOptions;
  return xssOriginal(dirty, options);
}

function xssStrip(dirty) {
  return xssOriginal(dirty, {
    whiteList: [], // empty, means filter out all tags
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script'], // the script tag is a special case, we need to filter out its content
  });
}

function xssEscapeHtml(html) {
  if (!html) {
    return '';
  }
  return escapeHtml(html);
}

export { xss, xssEscapeHtml, xssStrip };
